import { TRACKING_STAGES, TrackingOrder } from '../stages';

interface TrackingTimelineProps {
  order: TrackingOrder;
}

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

export default function TrackingTimeline({ order }: TrackingTimelineProps) {
  const currentIndex = TRACKING_STAGES.findIndex((s) => s.key === order.status);
  const resolvedIndex = currentIndex === -1 ? TRACKING_STAGES.length - 1 : currentIndex;

  const getEvent = (stageKey: string) =>
    Array.isArray(order.status_history)
      ? order.status_history.find((h) => h.status === stageKey)
      : undefined;

  return (
    <ol className="relative">
      {TRACKING_STAGES.map((stage, index) => {
        const isDone = index < resolvedIndex;
        const isCurrent = index === resolvedIndex;
        const isPending = index > resolvedIndex;
        const event = getEvent(stage.key);
        const isLast = index === TRACKING_STAGES.length - 1;

        return (
          <li key={stage.key} className="relative flex gap-4 pb-8 last:pb-0">
            {/* Linha vertical conectando */}
            {!isLast && (
              <span
                className={`absolute left-[22px] top-12 bottom-0 w-0.5 ${
                  isDone || isCurrent ? 'bg-[#E8610A]/30' : 'bg-gray-200'
                }`}
              />
            )}

            {/* Ícone do status */}
            <div
              className={`relative z-10 w-11 h-11 flex items-center justify-center rounded-full flex-shrink-0 ${
                isDone
                  ? 'bg-[#E8610A] text-white'
                  : isCurrent
                  ? 'bg-[#E8610A] text-white ring-4 ring-[#E8610A]/20'
                  : 'bg-gray-100 text-gray-400'
              }`}
            >
              <i className={`${isDone ? 'ri-check-line' : stage.icon} text-lg`}></i>
            </div>

            {/* Texto */}
            <div className="pt-1 flex-1">
              <div className="flex items-center gap-2 flex-wrap">
                <span
                  className={`font-semibold ${
                    isPending ? 'text-gray-400' : 'text-gray-900'
                  }`}
                >
                  {stage.label}
                </span>
                {isCurrent && (
                  <span className="text-[10px] font-bold uppercase tracking-wider text-[#E8610A] bg-[#E8610A]/10 px-2 py-0.5 rounded-full whitespace-nowrap">
                    Etapa atual
                  </span>
                )}
              </div>
              <p
                className={`text-sm mt-0.5 leading-relaxed ${
                  isPending ? 'text-gray-400' : 'text-gray-500'
                }`}
              >
                {stage.description}
              </p>
              {event?.date && (
                <p className="text-xs text-gray-400 mt-1">
                  {formatDate(event.date)}
                </p>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
}